// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Prompt } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteAufgabePrompt(): (
  aufgabeId: string,
  promptId: string
) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, promptId) =>
      (await getAPI()).prompts.deleteAufgabePrompt({ aufgabeId, promptId }),
    [getAPI]
  );
}
